import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { from, Observable, observable } from "rxjs";
import { Router, CanActivate } from "@angular/router";
// import { staffType, StaffMem } from "../app/pages/staff/staff.service";
import {
  AngularFirestore,
  AngularFirestoreDocument
} from "@angular/fire/firestore";
import { switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { NbToastrService, NbGlobalPosition, NbGlobalPhysicalPosition, NbComponentStatus } from '@nebular/theme';

@Injectable({
  providedIn: "root"
})
export class LoginService {
  userData: Observable<firebase.User>;
  // user$: Observable<StaffMem>;

  destroyByClick = true;
  duration = 2000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  preventDuplicates = false;
  status: NbComponentStatus = "success";

  constructor(
    private angularFireAuth: AngularFireAuth,
    private router: Router,
    private afs: AngularFirestore,
    private toastrService: NbToastrService

  ) {
    this.userData = angularFireAuth.authState;
  }
  isLoggedIn() {
    return this.angularFireAuth.auth.currentUser;
  }

  isAuthenticated() {
    if (this.angularFireAuth.auth.currentUser != null) {
      return true;
    } else {
      return false;
    }
  }



  getMail() {
    return this.angularFireAuth.auth.currentUser.email;
  }

  SignIn(email: string, password: string) {
    this.angularFireAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then(res => {
        console.log("You are successfully logged in");
        localStorage.setItem("email", email);
        // console.log(localStorage.getItem("email"));

        this.afs.collection("mechanics")
          .doc(email.trim())
          .ref.get()
          .then(val => {
            if (val.exists) {
              console.log("you are a mechanic");
              return;

            }
            else {
              this.afs.collection("customers")
                .doc(email.trim())
                .ref.get()
                .then(val => {
                  if (val.exists) {
                    console.log("You are a Customer");
                    // this.toastrService.show("Login Error", "You are a Customer");
                  }
                  else {
                    this.router.navigate(["/pages/mechanics/add-mechanic"]);

                  }
                })
            }
          })



        // this.router.navigate(["/pages/mechanics/add-mechanic"]);
      })
      .catch(err => {
        console.log("Something is wrong", err.message);
      });
  }

  SignOut() {
    this.angularFireAuth.auth.signOut();
  }
  // getEmail() {
  //   return this.angularFireAuth.auth.currentUser.email;
  // }

  static isAdmin() {
    // console.log(LoginService.tempMail);
    // console.log(LoginService.tempMail == "dulajdanu@gmail.com");
    //return LoginService.tempMail == "dulajdanu@gmail.com";
    // console.log(LoginService.tempMail);
  }
}
